import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import Image from "next/image"
import { useContext } from "react"
import { SwiperImage } from "@/app/types/searchTypes";
import GeneralSwiper from "../shared/swipers/GeneralSwiper"
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader"

const AccordionCard = ({ data, hasSwiper, SwiperMedia , index , cardTitle, insideAmenitiesDetailsPage, optimizedImage }: any) => {
	const { isIpad } = useContext(screenSizeContext)

	const transformedMedia: SwiperImage[] = SwiperMedia?.map((item: any, index: number) => ({
		src: item?.url,
		type: item?.type || "image",
		alt: `Swiper Image ${index + 1}`,
		id: index,
	}));

	const mediaSrc = isIpad
		? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + data?.media[1]?.media_name
		: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + data?.media[0]?.media_name;

	return (
		<div
			className={`${data.bg} 
        flex 
        flex-col
        px bg h-[100%] pt-6 pb-12
      	lg:grid lg:grid-cols-2 lg:gap-[15rem] lg:pt-10 lg:pb-10`}
		>
			<div className="col-span-1">
				<h2 className="text-h5 text-oBlack-100  min-h-[4.5rem]">
					{data?.title?.en}
				</h2>
				<p className="font-national text-bodyM text-oBlack-60 mb-10 whitespace-break-spaces lg:mb-0 mt-6 lg:mt-[4.5rem]">
					{data?.description?.en}
				</p>
			</div>
			<div className="flex justify-end">
				<div className={`relative col-span-1 w-[100%] ${hasSwiper ? "h-[22rem]" :"h-[24.9rem]"}  lg:h-[43rem] lg:w-[40rem]`}>
					{data.img && !optimizedImage && <Image src={data.img} alt="event" fill />}

					{data?.media[0]?.media_name && !hasSwiper && (
						optimizedImage ? (
							<ImageWithLoader
								src={mediaSrc}
								alt={data?.title?.en || "event"}
								sizeVariant="twoCol"
								quality={80}
							/>
						) : (
							<Image
								src={mediaSrc}
								alt={"event"}
								fill
							/>
						)
					)}

					{
						hasSwiper && (
							<div onClick={(e) => {
								e.stopPropagation();
							}}>

								<GeneralSwiper
									images={transformedMedia}
									slidesPerView={isIpad && transformedMedia?.length > 1 ? 1.2 : 1}
									isMultiple
									navigationIndex={`accordion-card-${cardTitle.replace(/\s+/g, "")}-${index}`}
									enableFullScreenSwiper
									customImgclass="h-full w-full"
									FullWidth
									swiperClass="!py-0"
									ImgHeight="h-[22rem] lg:h-[43rem]"
									useOuterPopup
									insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
								/>
							</div>
						)
					}
				</div>
			</div>
		</div>
	)
}

export default AccordionCard
